import React from 'react';
import './global.scss';

import { ModalProvider } from './shared/ModalContext';
import { useSiteBehavior } from './shared/useSiteBehavior';

import Header from './components/Header/Header';
import BannerSec from './components/BannerSec/BannerSec';
import AboutSec from './components/AboutSec/AboutSec';
import AdvantagesSec from './components/AdvantagesSec/AdvantagesSec';
import ServicesSec from './components/ServicesSec/ServicesSec';
import OurJourneySec from './components/OurJourneySec/OurJourneySec';
import HomeBlog from './components/OurBlog/Blog';
import HowWorks from './components/HowWorksSec/HowWorks';
import OurNetwork from './components/OurNetworkSec/OurNetwork';
import WhoWeAre from './components/WhoWeareSec/WhoWeAre';
import ClientsSec from './components/ClientsSec/ClientsSec';
import ContactSec from './components/ContactSec/ContactSec';
import Footer from './components/Footer/Footer';
import ContactModal from './components/ContactModal/ContactModal';
import heroVideo from './assets/Banner-vid2.mp4';
import flightVideo3 from './assets/flight-opt3.mp4';

/**
 * Layout note: in the source, `.clients` and `.contact` sit inside a
 * `.footer__video-container` > `.video-bg-wrapper` wrapper alongside a
 * sticky background video (`.sticky-video`) — the video pins in place via
 * `position: sticky` while Clients + Contact scroll on top of it
 * (`.sections-overlay` pulls them up with a negative margin-top). That
 * wrapper is kept here rather than folded into either section, since it's
 * a shared visual backdrop for both, not something either section owns.
 */
function AppContent() {
  useSiteBehavior();

  return (
    <div className="esq-page">
      <Header />
      <div className="hero__video-container">
        <div className="video-bg-wrapper">
          <div className="sticky-video">
            <video autoPlay className="hero__video" loop muted playsInline preload="auto" src={heroVideo} />
            <div className="hero__video-overlay" />
          </div>
          <div className="sections-overlay">
            <BannerSec />
            <AboutSec />
          </div>
        </div>
      </div>
      <ServicesSec />
      <AdvantagesSec />

      <HowWorks />
      <HomeBlog />
      <OurNetwork />
      <WhoWeAre />
      <OurJourneySec />
      <div className="footer__video-container">
        <div className="video-bg-wrapper">
          <div className="sticky-video">
            <video autoPlay className="footer__video" loop muted playsInline src={flightVideo3} />
          </div>
          <div className="sections-overlay">
            <ClientsSec />
            <ContactSec />
          </div>
          <Footer />
        </div>

      </div>


      <ContactModal />
    </div>
  );
}

const App = () => (
  <ModalProvider>
    <AppContent />
  </ModalProvider>
);

export default App;
